import * as React from 'react';
import { FC } from 'react';

import {ICommonComponentProps} from '../../definitions/common.definitions';
import styles from './content.module.css';

const Content: FC<ICommonComponentProps> = ({ children }) => {
  return (
    <div
      className={styles.contentWrapper}
    >
      {children}
    </div>
  );
}

export default Content;